import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { createWSPartnersAPI, getCnpjAPI, getWSPartnersAPI, updateWSPartnersAPI } from "./endpoints";

function* getWsPartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getWSPartnersAPI, action.payload);
    yield put(actions.setWsPartners(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* createWsPartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(createWSPartnersAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getWsPartners(action.payload.filter));
      yield put(
        commonActions.setAlert({
          message: "WS Partner Created Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "WS Partners Create Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* updateWsPartnersSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(updateWSPartnersAPI, action.payload);
    if (_api?.data?.success) {
      yield put(actions.getWsPartners(action.payload.filter));
      yield put(
        commonActions.setAlert({
          message: "WS Partner Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "WS Partners Update Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getCnpjSaga(action) {
  try {
    yield put(actions.cnpjLoader(true));
    const _api = yield call(getCnpjAPI, action.payload);
    yield put(actions.setCnpj(_api.data.results));
    yield put(actions.cnpjLoader(false));
  } catch (error) {
    yield put(actions.cnpjLoader(false));
    console.log(error);
  }
}

export function* withWSPartnersSaga() {
  yield all([
    takeEvery(actionTypes.GET_WS_PARTNERS, getWsPartnersSaga),
    takeEvery(actionTypes.CREATE_WS_PARTNERS, createWsPartnersSaga),
    takeEvery(actionTypes.UPDATE_WS_PARTNERS, updateWsPartnersSaga),
    takeEvery(actionTypes.GET_CNPJ, getCnpjSaga),
  ]);
}
